import { PaneArea } from '../../types/shared'
import Curve, { ICurveAttrs } from '../canvas/curve'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = ICurveAttrs
type PartialAttrs = Partial<Attrs>

const TOTAL_CURVE_POINTS_COUNT = 3

class CurveCreator extends Curve<Attrs> {
  mouseDowns = 1
  isCreator = true
  curvePoints = 1

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = this.attrs.x2 = startArea.x
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.curvePoints++
    if (this.curvePoints === TOTAL_CURVE_POINTS_COUNT) {
      this.release()
      this.replaceMyself(Curve.fromObject<Curve>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    switch (this.curvePoints) {
      case 1:
        this.attrs = {
          ...this.attrs,
          x2: area.x,
          y2: area.y,
        }
        break
      case 2:
        this.attrs = {
          ...this.attrs,
          x3: area.x,
          y3: area.y,
        }
        break
      default:
        break
    }
    this.trigger('change')
  }
}

export default CurveCreator
